import Vue from "vue";
import Router from "vue-router";
import { Auth } from "@/api";
import axios from 'axios'
// import { navItem } from '../_nav'

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

// TODO: Restructur Auth and page default
// Auth
const Login = () => import("@/views/auth/Login");
const ForgotPass = () => import("@/views/auth/forgotPass");
const ResetPass = () => import("@/views/auth/resetPass");

const FaceLogs = () => import("@/views/pages/logs/faceLogs");
const CancelLogs = () => import("@/views/pages/logs/cancelLogs");

const FinanceBankBook = () => import("@/views/pages/finance/bank_book");

const GroupFitnessBestOfTheBest = () => import("@/views/pages/groupFitness/bestOfTheBest");

const FinanceTermMembership = () => import("@/views/pages/finance/term_membership");
const FinanceRunningPTBalance = () => import("@/views/pages/finance/running_pt_balance");

const FinanceMembershipLog = () =>
  import("@/views/pages/finance/membership_log");

const RevenueLog = () => import("@/views/pages/finance/revenue_log");

const FinancePtLog = () => import("@/views/pages/finance/pt_log");

const FinancePtRunning = () => import("@/views/pages/finance/pt_running");

const FinanceLastDuesRecognitionLog = () =>
  import("@/views/pages/finance/last_dues_recognition_log");

const FinanceMerchandiseLog = () =>
  import("@/views/pages/finance/merchandise_log");

const FinancePTSessionAnalysis = () =>
  import("@/views/pages/finance/report_pt_session");

const FinanceMembershipAnalysis = () =>
  import("@/views/pages/finance/report_membership");

const FinanceRedeemPointReport = () =>
  import("@/views/pages/finance/redeem_point");

const ClosingPeriodMenu = () =>
  import("@/views/pages/closingPeriod/index");

// Pages Default
const Loading = () => import("@/views/pages/loading");
const Scan = () => import("@/views/scan/index");
const ScanClasses = () => import("@/views/scan/classes");
const ScanDetail = () => import("@/views/scan/detail");
const ScanDetailLapiaza = () => import("@/views/scan/detailLapiaza");
const ScanDetailDarmawangsa = () => import("@/views/scan/detailDarmawangsa");
const ScanDetailSMS = () => import("@/views/scan/detailSms");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const SiteConfiguration = () => import("@/views/pages/siteConfiguration");
const PendingDoc = () => import("@/views/pages/pendingDoc");
// Leads
const Leads = () => import("@/views/pages/leads/index");
const AddLead = () => import("@/views/pages/leads/add");
const AddMultipleLeads = () => import("@/views/pages/leads/addMultiple");
const EditLead = () => import("@/views/pages/leads/edit");
const DetailLead = () => import("@/views/pages/leads/detail");
const ConvertLead = () => import("@/views/pages/leads/convert");
const AssignLeads = () => import("@/views/pages/leads/assign");
const EhaForm = () => import("@/views/pages/leads/eha");
const EhaFormView = () => import("@/views/pages/leads/ehaView");
const EhaFormEdit = () => import("@/views/pages/leads/ehaEdit");
const Checkout = () => import("@/views/pages/leads/checkout");
const TransferLeads = () => import("@/views/pages/leads/transfer");

// Member Data
const MemberData = () => import("@/views/pages/memberData/index");
const PhaForm = () => import("@/views/pages/memberData/pha");
const DetailMember = () => import("@/views/pages/memberData/detailMember");
const LinkPrivyId = () => import("@/views/pages/memberData/linkPrivyId");
const MyCalendar = () => import("@/views/pages/memberData/myCalendar");

// Member Voucher
const MemberVoucher = () => import("@/views/pages/memberVoucher/index");
const AddMemberVoucher = () => import("@/views/pages/memberVoucher/add");
// const EditMemberVoucher = () =>
//   import('@/views/pages/memberVoucher/edit')

// Voucher
const Vouchers = () => import("@/views/pages/vouchers/index");
const AddVouchers = () => import("@/views/pages/vouchers/add");
const EditVouchers = () => import("@/views/pages/vouchers/edit");

// New Reports
const ReportAutoPay = () => import("@/views/pages/reports/autopay");
const ReportMotto = () => import("@/views/pages/reports/motto");
const ReportNewAutoCollection = () => import("@/views/pages/reports/autoCollection");
const ReportAutoPayResults = () => import("@/views/pages/reports/autopayresults");
const ReportMemberOutstanding = () => import("@/views/pages/reports/outstanding");
const ReportPtFeedback = () => import("@/views/pages/reports/ptFeedback");
const ReportSessionExpired = () => import("@/views/pages/reports/sessionExpired");

// Member Diary
const ListMemberDiary = () =>
  import("@/views/pages/memberData/listMemberDiary");
const AddMemberDiary = () => import("@/views/pages/memberData/addMemberDiary");
const EditMemberDiary = () =>
  import("@/views/pages/memberData/editMemberDiary");

const AddSecondMemberDiary = () =>
  import("@/views/pages/memberData/addSecondMemberDiary");

const AddFirstAssessment = () =>
  import("@/views/pages/memberData/addFirstAssessment");

const addWeeklyLogAssessment = () =>
  import("@/views/pages/memberData/addWeeklyLogAssessment");

const add2to4weeksChecking = () =>
  import("@/views/pages/memberData/add2to4weeksChecking");

// Sales Report
const GuestRegister = () => import("@/views/pages/salesReport/guestRegister");
const SalesLog = () => import("@/views/pages/salesReport/salesLog");
const SalesBackToBasic = () =>
  import("@/views/pages/salesReport/salesBackToBasic");
const NewDailyDPR = () => import("@/views/pages/salesReport/newDailyDPR");
const SalesBestOfTheBest = () =>
  import("@/views/pages/salesReport/salesBestOfTheBest");

const ListDailyDPRGoals = () =>
  import("@/views/pages/salesReport/dailyDPRGoals/index");
const AddDailyDPRGoals = () =>
  import("@/views/pages/salesReport/dailyDPRGoals/add");
const EditDailyDPRGoals = () =>
  import("@/views/pages/salesReport/dailyDPRGoals/edit");

const MemberPHA = () => import("@/views/pages/memberPha/index");
const ReschedulePha = () => import("@/views/pages/memberPha/reschedule");

const MemberPHAAssign = () => import("@/views/pages/memberPhaAssign/index");
const AssigningMemberPHA = () => import("@/views/pages/memberPhaAssign/assign");

const MemberPHAAppointment = () =>
  import("@/views/pages/memberPhaAppointment/index");

const MemberPhaHistory = () => import("@/views/pages/memberPhaHistory/index");

const ListMemberEntry = () => import("@/views/pages/memberEntry/index");
const DetailMemberEntry = () => import("@/views/pages/memberEntry/edit");
const ConvertMemberEntry = () => import("@/views/pages/memberEntry/convert");
const EditGymMemberEntry = () => import("@/views/pages/memberEntry/editGym");
const MyPoints = () => import("@/views/pages/memberEntry/myPoint");
const EditClassMemberEntry = () =>
  import("@/views/pages/memberEntry/editClass");
const EditBookingMemberEntry = () =>
  import("@/views/pages/memberEntry/editBooking");
const EditTransactionMemberEntry = () =>
  import("@/views/pages/memberEntry/editTransaction");
const EditPtSessionMemberEntry = () =>
  import("@/views/pages/memberEntry/editPtSession");
const EditRunningSessionMemberEntry = () =>
  import("@/views/pages/memberEntry/editRunningSession");
const AddPtSessionMemberEntry = () =>
  import("@/views/pages/memberEntry/addPtSession");
const AddNewPtSessionMemberEntry = () =>
  import("@/views/pages/memberEntry/addNewPtSession");
const EditCreditCardMemberEntry = () =>
  import("@/views/pages/memberEntry/editCreditCard");
const EditRekeningMemberEntry = () =>
  import("@/views/pages/memberEntry/editRekening");
const EditBannedMember = () =>
  import("@/views/pages/memberEntry/editBannedMember");

const SchedulePtAppointment = () =>
  import("@/views/pages/schedulePtAppointment/index");

const GymAttendance = () => import("@/views/pages/attendance/gym");
const GymAttendanceManualAdd = () =>
  import("@/views/pages/attendance/gym_manual_add");
const ClassAttendance = () => import("@/views/pages/attendance/class");
const ClassAttendanceManualAdd = () =>
  import("@/views/pages/attendance/class_manual_add");
const GroupFitnessNewAttendance = () =>
  import("@/views/pages/attendance/group_fitness");

const GroupFitnessBotb = () =>
  import("@/views/pages/attendance/group_fitness_botb");

const InstructorAttendance = () =>
  import("@/views/pages/attendance/instructor");

const BookingHistory = () => import("@/views/pages/history/booking");
const TransactionHistory = () => import("@/views/pages/history/transaction");

const SlideBanner = () => import("@/views/pages/slideBanner/index");
const AddSlideBanner = () => import("@/views/pages/slideBanner/add");
const EditSlideBanner = () => import("@/views/pages/slideBanner/edit");

const Classes = () => import("@/views/pages/classes/index");
const AddClasses = () => import("@/views/pages/classes/add");
const EditClasses = () => import("@/views/pages/classes/edit");

const ClassesTime = () => import("@/views/pages/classesTime/index");
const AddClassesTime = () => import("@/views/pages/classesTime/add");
const EditClassesTime = () => import("@/views/pages/classesTime/edit");

const Studio = () => import("@/views/pages/studio/index");
const AddStudio = () => import("@/views/pages/studio/add");
const EditStudio = () => import("@/views/pages/studio/edit");
const CyclingLayouts = () => import("@/views/pages/studio/cylingLayout");

const ClassCategory = () => import("@/views/pages/classCategory/index");
const AddClassCategory = () => import("@/views/pages/classCategory/add");
const EditClassCategory = () => import("@/views/pages/classCategory/edit");

const Schedule = () => import("@/views/pages/schedule/index");
const AddSchedule = () => import("@/views/pages/schedule/add");
const EditSchedule = () => import("@/views/pages/schedule/edit");

const Coach = () => import("@/views/pages/coach/index");
const AddCoach = () => import("@/views/pages/coach/add");
const EditCoach = () => import("@/views/pages/coach/edit");

const Blog = () => import("@/views/pages/blog/index");
const AddBlog = () => import("@/views/pages/blog/add");
const EditBlog = () => import("@/views/pages/blog/edit");

const BlogCategory = () => import("@/views/pages/blogCategory/index");
const AddBlogCategory = () => import("@/views/pages/blogCategory/add");
const EditBlogCategory = () => import("@/views/pages/blogCategory/edit");

const MemberPrivilegeCategory = () =>
  import("@/views/pages/memberPrivilegeCategory/index");
const AddMemberPrivilegeCategory = () =>
  import("@/views/pages/memberPrivilegeCategory/add");
const EditMemberPrivilegeCategory = () =>
  import("@/views/pages/memberPrivilegeCategory/edit");

const PersonalTraining = () => import("@/views/pages/personalTraining/index");
const AddPersonalTraining = () => import("@/views/pages/personalTraining/add");
const EditPersonalTraining = () =>
  import("@/views/pages/personalTraining/edit");

const Sales = () => import("@/views/pages/sales/index");
const AddSales = () => import("@/views/pages/sales/add");
const EditSales = () => import("@/views/pages/sales/edit");

const SalesMapping = () => import("@/views/pages/salesMapping/index");
const AddSalesMapping = () => import("@/views/pages/salesMapping/add");
const EditSalesMapping = () => import("@/views/pages/salesMapping/edit");

const User = () => import("@/views/pages/userManagement/user");
const AddUser = () => import("@/views/pages/userManagement/addUser");
const EditUser = () => import("@/views/pages/userManagement/editUser");

const UserRole = () => import("@/views/pages/userManagement/userRole/index");
const AddUserRole = () => import("@/views/pages/userManagement/userRole/add");
const EditUserRole = () => import("@/views/pages/userManagement/userRole/edit");

// approval roles
const ApprovalRoles = () => import("@/views/pages/userManagement/approvalRoles/index");
const ApprovalRolesAdd = () => import("@/views/pages/userManagement/approvalRoles/add");
const ApprovalRolesEdit = () => import("@/views/pages/userManagement/approvalRoles/edit");

const UserAccessMenu = () =>
  import("@/views/pages/userManagement/userAccessMenu/index");
const AddUserAccessMenu = () =>
  import("@/views/pages/userManagement/userAccessMenu/add");
const EditUserAccessMenu = () =>
  import("@/views/pages/userManagement/userAccessMenu/edit");

const UserRoleMapping = () =>
  import("@/views/pages/userManagement/userRoleMapping/index");
const AddUserRoleMapping = () =>
  import("@/views/pages/userManagement/userRoleMapping/add");
const EditUserRoleMapping = () =>
  import("@/views/pages/userManagement/userRoleMapping/edit");

const SalesManager = () =>
  import("@/views/pages/userManagement/salesManager/index");
const AddSalesManager = () =>
  import("@/views/pages/userManagement/salesManager/add");
const EditSalesManager = () =>
  import("@/views/pages/userManagement/salesManager/edit");

const CustomerServices = () => import("@/views/pages/userManagement/cs/index");
const AddCustomerServices = () => import("@/views/pages/userManagement/cs/add");
const EditCustomerServices = () =>
  import("@/views/pages/userManagement/cs/edit");

const Branch = () => import("@/views/pages/branch/index");
const AddBranch = () => import("@/views/pages/branch/add");
const EditBranch = () => import("@/views/pages/branch/edit");

const PtSession = () => import("@/views/pages/ptSession/index");
const AddPtSession = () => import("@/views/pages/ptSession/add");
const EditPtSession = () => import("@/views/pages/ptSession/edit");

const PtLog = () => import("@/views/pages/ptReport/ptLog");
const PtBackToBasic = () => import("@/views/pages/ptReport/ptBackToBasic");
const PtBestOfTheBest = () => import("@/views/pages/ptReport/ptBestOfTheBest");
const PtCommissionSettingIndex = () =>
  import("@/views/pages/ptReport/ptCommissionSetting/index");
const PtCommissionSettingAdd = () =>
  import("@/views/pages/ptReport/ptCommissionSetting/add");
const PtCommissionTierIndex = () =>
  import("@/views/pages/ptReport/ptCommissionTier/index");
// const PtReportAssesment = () => import('@/views/pages/ptReport/assesment')
const PtReportUsageLog = () => import("@/views/pages/ptReport/usageLog");
const PtReportSalesCommission = () =>
  import("@/views/pages/ptReport/salesCommission");

const PtSessionBuy = () => import("@/views/pages/ptSessionBuy/index");
const AddPtSessionBuy = () => import("@/views/pages/ptSessionBuy/add");
const EditPtSessionBuy = () => import("@/views/pages/ptSessionBuy/edit");

const PtSessionMember = () => import("@/views/pages/ptSessionMember/index");
const AddPtSessionMember = () => import("@/views/pages/ptSessionMember/add");
const EditPtSessionMember = () => import("@/views/pages/ptSessionMember/edit");

const memberDiarySubCategory = () =>
  import("@/views/pages/memberDiary/subcategory/index");
const memberDiarySubCategoryManage = () =>
  import("@/views/pages/memberDiary/subcategory/manage");

const memberDiaryActivity = () =>
  import("@/views/pages/memberDiary/activity/index");
const memberDiaryActivityManage = () =>
  import("@/views/pages/memberDiary/activity/manage");

const AllForm = () => import("@/views/pages/allForm/index");
const AddForm = () => import("@/views/pages/allForm/add");
const AddFormFreeze = () => import("@/views/pages/allForm/addFreeze");
const AddFormCancel = () => import("@/views/pages/allForm/addCancel");
const AddFormDailyVisit = () => import("@/views/pages/allForm/addDailyVisit");
const EditFormDailyVisit = () => import("@/views/pages/allForm/editDailyVisit");
const AddFormOutstanding = () => import("@/views/pages/allForm/addOutstanding");
const AddFormMerchandise = () => import("@/views/pages/allForm/addMerchandise");
const AddFormStarterPack = () => import("@/views/pages/allForm/addStarterPack");
const AddFormLostAndFound = () =>
  import("@/views/pages/allForm/addLostAndFound");
const AddFormWristband = () => import("@/views/pages/allForm/addWristband");
const AddFormGrabAndGo = () => import("@/views/pages/allForm/addGrabAndGo");
const AddFormGrabAndGoGopay = () =>
  import("@/views/pages/allForm/addGrabAndGoGopay");
const EditFormGrabAndGo = () => import("@/views/pages/allForm/editGrabAndGo");
const EditFormGrabAndGoGopay = () =>
  import("@/views/pages/allForm/editGrabAndGoGopay");
const AddCorporateOutstanding = () =>
  import("@/views/pages/allForm/AddCorporateOutstanding");
const AddExtendForm = () => import("@/views/pages/allForm/addExtendPt");
const GrabAndGoProduct = () =>
  import("@/views/pages/allForm/grabAndGoProduct/index");
// const AddGrabAndGoProduct = () => import('@/views/pages/allForm/grabAndGoProduct/add')
const EditGrabAndGoProduct = () =>
  import("@/views/pages/allForm/grabAndGoProduct/edit");
// const EditForm = () => import('@/views/pages/form/edit')
const EditFormLostAndFound = () =>
  import("@/views/pages/allForm/editLostAndFound");
const EditCancel = () => import("@/views/pages/allForm/editCancel");
const EditFreeze = () => import("@/views/pages/allForm/editFreeze");
const EditCorporateOutstanding = () =>
  import("@/views/pages/allForm/editCorporateOutstanding");

const RegisterWristband = () => import("@/views/pages/registerWristband/index");

const ReportFreeze = () => import("@/views/pages/formReport/freeze");
const ReportExtend = () => import("@/views/pages/formReport/extend_pt");
const ReportCancel = () => import("@/views/pages/formReport/cancel");
const ReportOutstanding = () => import("@/views/pages/formReport/outstanding");
const ReportWristband = () => import("@/views/pages/formReport/wristband");
const ReportMemberVoucher = () => import("@/views/pages/formReport/member_voucher");
const ReportMemberPoint = () => import("@/views/pages/formReport/member_point");
const ReportLogUpdateFOP = () => import("@/views/pages/formReport/log_update_fop");


const MemberPointScheme = () => import("@/views/pages/memberPointScheme/index");

const ReportLostAndFound = () =>
  import("@/views/pages/formReport/lostAndFound");
const ReportDailyVisit = () => import("@/views/pages/formReport/dailyVisit");
const ReportGrabAndGo = () => import("@/views/pages/formReport/grabAndGo");
const ReportAutopayMidtrans = () =>
  import("@/views/pages/formReport/autopay_midtrans");
const ReportDraftBank = () => import("@/views/pages/formReport/draft_bank");
const ReportGrabAndGoGopay = () =>
  import("@/views/pages/formReport/grabAndGoGopay");
const ReportCorporateOutstanding = () =>
  import("@/views/pages/formReport/corporateOutstanding");

const ReportMerchandise = () => import("@/views/pages/formReport/merchandise");

const ApprovalMenu = () => import("@/views/pages/approval/index");

// auto collection
const ReportAutoCollection = () =>
  import("@/views/pages/formReport/autocollection");
const AddAutoCollection = () =>
  import("@/views/pages/formReport/add_autocollection");

const GroupFitnessAttendance = () =>
  import("@/views/pages/groupFitness/attendance");
const GroupFitnessComission = () =>
  import("@/views/pages/groupFitness/comission");
const GroupFitnessCNR = () => import("@/views/pages/groupFitness/cnr");
const GroupFitnessSummary = () => import("@/views/pages/groupFitness/summary");

const Faq = () => import("@/views/pages/faq/index");
const AddFaq = () => import("@/views/pages/faq/add");
const EditFaq = () => import("@/views/pages/faq/edit");

const Event = () => import("@/views/pages/event/index");
const AddEvent = () => import("@/views/pages/event/add");
const EditEvent = () => import("@/views/pages/event/edit");

const Membership = () => import("@/views/pages/membership/index");
const AddMembership = () => import("@/views/pages/membership/add");
const EditMembership = () => import("@/views/pages/membership/edit");

const CollectStamp = () => import("@/views/pages/collectStamp/index");
const addCollectStamp = () => import("@/views/pages/collectStamp/add");
const EditCollectStamp = () => import("@/views/pages/collectStamp/edit");

const MembershipSessionProrate = () =>
  import("@/views/pages/membershipSessionProrate/index");
const AddMembershipSessionProrate = () =>
  import("@/views/pages/membershipSessionProrate/add");
const EditMembershipSessionProrate = () =>
  import("@/views/pages/membershipSessionProrate/edit");

const Package = () => import("@/views/pages/package/index");
const AddPackage = () => import("@/views/pages/package/add");
const EditPackage = () => import("@/views/pages/package/edit");

const Transaction = () => import("@/views/pages/transaction/index");
const AddTransaction = () => import("@/views/pages/transaction/add");
const EditTransaction = () => import("@/views/pages/transaction/edit");

const Gallery = () => import("@/views/pages/gallery/index");
const AddGallery = () => import("@/views/pages/gallery/add");
const EditGallery = () => import("@/views/pages/gallery/edit");

const SettlementHistory = () =>
  import("@/views/pages/settlement/settlementHistory");
const SettlementSubmit = () =>
  import("@/views/pages/settlement/settlementSubmit");
const SettlementEdit = () => import("@/views/pages/settlement/settlementEdit");

const PTPlanner = () => import("@/views/pages/ptPlanner/index");
const AddPTPlanner = () => import("@/views/pages/ptPlanner/add");
const EditPTPlanner = () => import("@/views/pages/ptPlanner/edit");
const AddPTPlannerLeave = () =>
  import("@/views/pages/ptPlanner/addPlannerLeave");
const EditPTPlannerLeave = () =>
  import("@/views/pages/ptPlanner/editPlannerLeave");

// pt planner new
const PTPlannerNew = () => import("@/views/pages/ptPlannerNew/index");
const salesPlanner = () => import("@/views/pages/salesPlanner/index");

const AddPTPlannerNew = () => import("@/views/pages/ptPlannerNew/add");
const EditPTPlannerNew = () => import("@/views/pages/ptPlannerNew/edit");
const AddPTPlannerLeaveNew = () =>
  import("@/views/pages/ptPlannerNew/addPlannerLeave");
const EditPTPlannerLeaveNew = () =>
  import("@/views/pages/ptPlannerNew/editPlannerLeave");

const MemberBookings = () => import("@/views/pages/memberBookings/index");

// notification component
const Notification = () => import("@/views/pages/notification/index");
const AddNotification = () => import("@/views/pages/notification/add");
const NotificationPTDetail = () => import("@/views/pages/notification/personal_trainer");
const NotificationSalesDetail = () => import("@/views/pages/notification/sales");

const ChangePassword = () => import("@/views/auth/ChangePassword");

const MemberPrivilege = () => import("@/views/pages/memberPrivilege/index");
const AddMemberPrivilege = () => import("@/views/pages/memberPrivilege/add");
const EditMemberPrivilege = () => import("@/views/pages/memberPrivilege/edit");

const MemberWristband = () => import("@/views/pages/memberWristband/index");

const Corporate = () => import("@/views/pages/corporate/index");
const ManageCorporate = () => import("@/views/pages/corporate/manage");

const KeysoftHistory = () => import("@/views/pages/keysoft/history");
const ReportOutstandingPtSession = () =>
  import("@/views/pages/keysoft/report_outstanding");
const KeysoftSync = () => import("@/views/pages/keysoft/sync");

const FrontendSetting_GroupFitness = () =>
  import("@/views/pages/frontendSetting/GroupFitness/index");
const FrontendSetting_AddGroupFitness = () =>
  import("@/views/pages/frontendSetting/GroupFitness/add");
const FrontendSetting_EditGroupFitness = () =>
  import("@/views/pages/frontendSetting/GroupFitness/edit");

const FrontendSetting_Pha = () =>
  import("@/views/pages/frontendSetting/PHA/index");
const FrontendSetting_AddPha = () =>
  import("@/views/pages/frontendSetting/PHA/add");
const FrontendSetting_EditPha = () =>
  import("@/views/pages/frontendSetting/PHA/edit");

const FrontendSetting_Program = () =>
  import("@/views/pages/frontendSetting/Program/index");
const FrontendSetting_AddProgram = () =>
  import("@/views/pages/frontendSetting/Program/add");
const FrontendSetting_EditProgram = () =>
  import("@/views/pages/frontendSetting/Program/edit");

const FrontendSetting_VideoHome = () =>
  import("@/views/pages/frontendSetting/VideoHome/index");
const FrontendSetting_AddVideoHome = () =>
  import("@/views/pages/frontendSetting/VideoHome/add");
const FrontendSetting_EditVideoHome = () =>
  import("@/views/pages/frontendSetting/VideoHome/edit");

const FrontendSetting_VideoGF = () =>
  import("@/views/pages/frontendSetting/VideoGF/index");
const FrontendSetting_AddVideoGF = () =>
  import("@/views/pages/frontendSetting/VideoGF/add");
const FrontendSetting_EditVideoGF = () =>
  import("@/views/pages/frontendSetting/VideoGF/edit");

const FrontendSetting_VideoPT = () =>
  import("@/views/pages/frontendSetting/VideoPT/index");
const FrontendSetting_AddVideoPT = () =>
  import("@/views/pages/frontendSetting/VideoPT/add");
const FrontendSetting_EditVideoPT = () =>
  import("@/views/pages/frontendSetting/VideoPT/edit");

const FrontendSetting_ParadigmStandard = () =>
  import("@/views/pages/frontendSetting/ParadigmStandard");

const FrontendSetting_StudioSchedule = () =>
  import("@/views/pages/frontendSetting/StudioSchedule/index");
const FrontendSetting_AddStudioSchedule = () =>
  import("@/views/pages/frontendSetting/StudioSchedule/add");
const FrontendSetting_EditStudioSchedule = () =>
  import("@/views/pages/frontendSetting/StudioSchedule/edit");

Vue.use(Router);

const router = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/forgot_password",
      name: "Forgot Password",
      component: ForgotPass,
    },
    {
      path: "/reset_password/:slug",
      name: "Reset Password",
      component: ResetPass,
    },
    {
      path: "/loading",
      name: "Loading",
      component: Loading,
    },
    {
      path: "/scan",
      name: "Scan QR",
      component: Scan,
    },
    {
      path: "/scan/classes",
      name: "Scan QR Classes",
      component: ScanClasses,
    },
    {
      path: "/scan/detail",
      name: "Detail Scan QR",
      component: ScanDetail,
    },
    {
      path: "/scan/detail_lp",
      name: "Detail Scan QR Lapiaza",
      component: ScanDetailLapiaza,
    },
    {
      path: "/scan/detail_ds",
      name: "Detail Scan QR Darmawangsa",
      component: ScanDetailDarmawangsa,
    },
    {
      path: "/scan/sms",
      name: "Detail Scan QR Sumarecon Serpong",
      component: ScanDetailSMS,
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
      ],
    },
    {
      path: "/",
      meta: {
        requiresAuth: true,
        afterLogin: Auth.Session.get().paradigm_role,
      },
      beforeEnter(to, from, next) {
        if (
          to.meta.afterLogin === "3" ||
          to.meta.afterLogin === "4" ||
          to.meta.afterLogin === "6" ||
          to.meta.afterLogin === "13" ||
          to.meta.afterLogin === "17" ||
          to.meta.afterLogin === "35" ||
          to.meta.afterLogin === "34" ||
          to.meta.afterLogin === "20"
        ) {
          next({
            path: "/dashboard",
          });
        } else if (to.meta.afterLogin === "1" || to.meta.afterLogin === "2") {
          next({
            path: "/siteConfiguration",
          });
        } else if (
          to.meta.afterLogin === "7" ||
          to.meta.afterLogin === "18" ||
          to.meta.afterLogin === "19"
        ) {
          next({
            path: "/memberData",
          });
        } else next();
      },
      // name: 'CMS',
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          meta: {
            requiresAuth: true,
          },
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "change-password",
          meta: {
            requiresAuth: true,
          },
          name: "Change Password",
          component: ChangePassword,
        },
        {
          path: "leads",
          meta: {
            requiresAuth: true,
          },
          name: "All Leads",
          component: Leads,
        },
        {
          path: "app_leads",
          meta: {
            requiresAuth: true,
          },
          name: "Online Register",
          component: AssignLeads,
        },
        {
          path: "memberData",
          meta: {
            requiresAuth: true,
          },
          name: "Member Data",
          component: MemberData,
        },
        {
          path: "memberVoucher",
          meta: {
            requiresAuth: true,
          },
          name: "Member Voucher",
          component: MemberVoucher,
        },
        {
          path: "memberVoucher/add",
          meta: {
            requiresAuth: true,
          },
          name: "Add Member Voucher",
          component: AddMemberVoucher,
        },
        {
          path: "vouchers",
          meta: {
            requiresAuth: true,
          },
          name: "Voucher",
          component: Vouchers,
        },
        {
          path: "vouchers/add",
          meta: {
            requiresAuth: true,
          },
          name: "Add Voucher",
          component: AddVouchers,
        },
        {
          path: "vouchers/edit",
          meta: {
            requiresAuth: true,
          },
          name: "Edit Voucher",
          component: EditVouchers,
        },
        {
          path: "memberPha",
          meta: {
            requiresAuth: true,
          },
          name: "Member PHA",
          component: MemberPHA,
        },
        {
          path: "memberPhaAssign",
          meta: {
            requiresAuth: true,
          },
          name: "List Member Assign",
          component: MemberPHAAssign,
        },
        {
          path: "memberPhaAppointment",
          meta: {
            requiresAuth: true,
          },
          name: "List Member Appointment",
          component: MemberPHAAppointment,
        },
        {
          path: "memberPhaAssign/assign",
          meta: {
            requiresAuth: true,
          },
          name: "Assigning Member PHA",
          component: AssigningMemberPHA,
        },
        {
          path: "MemberPhaHistory",
          meta: {
            requiresAuth: true,
          },
          name: "Member PHA History",
          component: MemberPhaHistory,
        },
        {
          path: "memberPha/reschedule",
          meta: {
            requiresAuth: true,
          },
          name: "Reschedule PHA",
          component: ReschedulePha,
        },
        {
          path: "memberData/detail",
          meta: {
            requiresAuth: true,
          },
          name: "Detail Member",
          component: DetailMember,
        },
        {
          path: "memberData/phaForm",
          meta: {
            requiresAuth: true,
          },
          name: "PHA Form",
          component: PhaForm,
        },
        {
          path: "memberData/addMemberDiary",
          meta: {
            requiresAuth: true,
          },
          name: "Add Member Diary",
          component: AddMemberDiary,
        },
        {
          path: "memberData/addSecondMemberDiary",
          meta: {
            requiresAuth: true,
          },
          name: "Add Member Diary",
          component: AddSecondMemberDiary,
        },
        {
          path: "memberData/addFirstAssessment",
          meta: {
            requiresAuth: true,
          },
          name: "First Assessment",
          component: AddFirstAssessment,
        },
        {
          path: "memberData/addWeeklyLogAssessment",
          meta: {
            requiresAuth: true,
          },
          name: "Weekly Log",
          component: addWeeklyLogAssessment,
        },
        {
          path: "memberData/add2to4weeksChecking",
          meta: {
            requiresAuth: true,
          },
          name: "2 to 4 Weeks Checking",
          component: add2to4weeksChecking,
        },
        {
          path: "memberData/editMemberDiary",
          meta: {
            requiresAuth: true,
          },
          name: "Edit Member Diary",
          component: EditMemberDiary,
        },
        {
          path: "memberData/listMemberDiary",
          meta: {
            requiresAuth: true,
          },
          name: "List Member Diary",
          component: ListMemberDiary,
        },
        {
          path: "leads/checkout",
          meta: {
            requiresAuth: true,
          },
          name: "Registration Card",
          component: Checkout,
        },
        {
          path: "leads/linkPrivyId",
          meta: {
            requiresAuth: true,
          },
          name: "Link PrivyId",
          component: LinkPrivyId,
        },
        {
          path: "leads/add",
          meta: {
            requiresAuth: true,
          },
          name: "Add Lead",
          component: AddLead,
        },
        {
          path: "leads/addMultiple",
          meta: {
            requiresAuth: true,
          },
          name: "Add Multiple Leads",
          component: AddMultipleLeads,
        },
        {
          path: "transferLeads",
          meta: {
            requiresAuth: true,
          },
          name: "Transfer Lead",
          component: TransferLeads,
        },
        {
          path: "leads/edit",
          meta: {
            requiresAuth: true,
          },
          name: "Edit Lead",
          component: EditLead,
        },
        {
          path: "leads/detail",
          meta: {
            requiresAuth: true,
          },
          name: "Detail Lead",
          component: DetailLead,
        },
        {
          path: "leads/eha",
          meta: {
            requiresAuth: true,
          },
          name: "EHA Form",
          component: EhaForm,
        },
        {
          path: "leads/ehaView",
          meta: {
            requiresAuth: true,
          },
          name: "EHA Form View",
          component: EhaFormView,
        },
        {
          path: "leads/ehaEdit",
          meta: {
            requiresAuth: true,
          },
          name: "EHA Form Edit",
          component: EhaFormEdit,
        },
        {
          path: "leads/convert",
          meta: {
            requiresAuth: true,
          },
          name: "Convert Lead",
          component: ConvertLead,
        },
        {
          path: "salesReport/guestRegister",
          meta: {
            requiresAuth: true,
          },
          name: "Guest Register",
          component: GuestRegister,
        },
        {
          path: "salesReport/salesLog",
          meta: {
            requiresAuth: true,
          },
          name: "Sales Log",
          component: SalesLog,
        },
        {
          path: "salesReport/salesBackToBasic",
          meta: {
            requiresAuth: true,
          },
          name: "Sales Back To Basic",
          component: SalesBackToBasic,
        },
        {
          path: "salesReport/dailyDPR",
          meta: {
            requiresAuth: true,
          },
          name: "Daily DPR",
          component: NewDailyDPR,
        },
        {
          path: "salesReport/salesBestOfTheBest",
          meta: {
            requiresAuth: true,
          },
          name: "Sales Best Of TheBest",
          component: SalesBestOfTheBest,
        },
        {
          path: "dailyDPRGoals/index",
          meta: {
            requiresAuth: true,
          },
          name: "List Daily DPR Goals",
          component: ListDailyDPRGoals,
        },
        {
          path: "dailyDPRGoals/add",
          meta: {
            requiresAuth: true,
          },
          name: "Add Daily DPR Goals",
          component: AddDailyDPRGoals,
        },
        {
          path: "dailyDPRGoals/edit",
          meta: {
            requiresAuth: true,
          },
          name: "Edit Daily DPR Goals",
          component: EditDailyDPRGoals,
        },
        {
          path: "settlement/history",
          meta: {
            requiresAuth: true,
          },
          name: "Settlement History",
          component: SettlementHistory,
        },
        {
          path: "settlement/submit",
          meta: {
            requiresAuth: true,
          },
          name: "Settlement Submit",
          component: SettlementSubmit,
        },
        {
          path: "settlement/edit",
          meta: {
            requiresAuth: true,
          },
          name: "Settlement Edit",
          component: SettlementEdit,
        },
        {
          path: "ptPlanner",
          meta: {
            requiresAuth: true,
          },
          name: "PT Planner",
          component: PTPlanner,
        },
        {
          path: "ptPlanner/add",
          meta: {
            requiresAuth: true,
          },
          name: "Add PT Planner",
          component: AddPTPlanner,
        },
        {
          path: "ptPlanner/edit",
          meta: {
            requiresAuth: true,
          },
          name: "Edit PT Planner",
          component: EditPTPlanner,
        },
        {
          path: "ptPlanner/addPlannerLeave",
          meta: {
            requiresAuth: true,
          },
          name: "Add PT Planner Leave",
          component: AddPTPlannerLeave,
        },
        {
          path: "ptPlanner/editPlannerLeave",
          meta: {
            requiresAuth: true,
          },
          name: "Edit PT Planner Leave",
          component: EditPTPlannerLeave,
        },
        {
          path: "ptPlannerNew",
          meta: {
            requiresAuth: true,
          },
          name: "PT Planner New",
          component: PTPlannerNew,
        },
        {
          path: "salesPlanner",
          meta: {
            requiresAuth: true,
          },
          name: "Sales Planner",
          component: salesPlanner,
        },
        {
          path: "ptPlannerNew/add",
          meta: {
            requiresAuth: true,
          },
          name: "Add PT Planner",
          component: AddPTPlannerNew,
        },
        {
          path: "ptPlannerNew/edit",
          meta: {
            requiresAuth: true,
          },
          name: "Edit PT Planner",
          component: EditPTPlannerNew,
        },
        {
          path: "ptPlannerNew/addPlannerLeave",
          meta: {
            requiresAuth: true,
          },
          name: "Add PT Planner Leave",
          component: AddPTPlannerLeaveNew,
        },
        {
          path: "memberBookings",
          meta: {
            requiresAuth: true,
          },
          name: "Bookings",
          component: MemberBookings,
        },
        {
          path: "ptPlannerNew/editPlannerLeave",
          meta: {
            requiresAuth: true,
          },
          name: "Edit PT Planner Leave",
          component: EditPTPlannerLeaveNew,
        },
        {
          path: "notification",
          meta: {
            requiresAuth: true,
          },
          name: "Notifications",
          component: Notification,
        },
        {
          path: "notification/add",
          meta: {
            requiresAuth: true,
          },
          name: "Add Notification",
          component: AddNotification,
        },
        {
          path: "notification/personal_trainer",
          meta: {
            requiresAuth: true,
          },
          name: "My Notification",
          component: NotificationPTDetail,
        },
        {
          path: "notification/sales",
          meta: {
            requiresAuth: true,
          },
          name: "My Notification",
          component: NotificationSalesDetail,
        },
        {
          path: "myCalendar",
          meta: {
            requiresAuth: true,
          },
          name: "My Calendar",
          component: MyCalendar,
        },
        {
          path: "siteConfiguration",
          name: "Site Configuration",
          meta: {
            requiresAuth: true,
          },
          component: SiteConfiguration,
        },
        {
          path: "pendingDoc",
          name: "Pending Documents",
          meta: {
            requiresAuth: true,
          },
          component: PendingDoc,
        },
        {
          path: "pendingDocuments",
          meta: {
            newTab: true,
          },
          beforeEnter(to, from, next) {
            if (to.meta.newTab) {
              // console.log('haha', to.meta.newTab)
              next({
                path: "/pendingDoc",
              });
              window.open("https://web.privy.id/");
            } else next();
          },
        },
        {
          path: "memberEntry",
          name: "Member Data Entry",
          meta: {
            requiresAuth: true,
            id: 30
          },
          component: ListMemberEntry,
        },
        {
          path: "memberEntry/edit",
          name: "Edit Data Member",
          meta: {
            requiresAuth: true,
          },
          component: DetailMemberEntry,
        },
        {
          path: "memberEntry/convert",
          name: "Convert Data Member",
          meta: {
            requiresAuth: true,
          },
          component: ConvertMemberEntry,
        },
        {
          path: "memberEntry/editGym",
          name: "Edit Data Gym Attendance",
          meta: {
            requiresAuth: true,
          },
          component: EditGymMemberEntry,
        },
        {
          path: "memberEntry/myPoints",
          name: "My Points",
          meta: {
            requiresAuth: true,
          },
          component: MyPoints,
        },
        {
          path: "memberEntry/editClass",
          name: "Edit Data Class Attendance",
          meta: {
            requiresAuth: true,
          },
          component: EditClassMemberEntry,
        },
        {
          path: "memberEntry/editBooking",
          name: "Edit Data Booking",
          meta: {
            requiresAuth: true,
          },
          component: EditBookingMemberEntry,
        },
        {
          path: "memberEntry/editTransaction",
          name: "Edit Data Transaction ",
          meta: {
            requiresAuth: true,
          },
          component: EditTransactionMemberEntry,
        },
        {
          path: "memberEntry/editPtSession",
          name: "Edit Data PT Session",
          meta: {
            requiresAuth: true,
          },
          component: EditPtSessionMemberEntry,
        },
        {
          path: "memberEntry/editBannedMember",
          name: "Edit Banned Member",
          meta: {
            requiresAuth: true,
          },
          component: EditBannedMember,
        },
        {
          path: "memberEntry/editRunningSession",
          name: "Edit Running PT Session",
          meta: {
            requiresAuth: true,
          },
          component: EditRunningSessionMemberEntry,
        },
        {
          path: "memberEntry/addPtSession",
          name: "Add Data PT Session",
          meta: {
            requiresAuth: true,
          },
          component: AddPtSessionMemberEntry,
        },
        {
          path: "memberEntry/addNewPtSession",
          name: "Add New PT Session",
          meta: {
            requiresAuth: true,
          },
          component: AddNewPtSessionMemberEntry,
        },
        {
          path: "memberEntry/editCreditCard",
          name: "Edit Data Credit Card",
          meta: {
            requiresAuth: true,
          },
          component: EditCreditCardMemberEntry,
        },
        {
          path: "memberEntry/editRekening",
          name: "Edit Data Rekening",
          meta: {
            requiresAuth: true,
          },
          component: EditRekeningMemberEntry,
        },
        {
          path: "class_attendance",
          name: "Class Attendance",
          meta: {
            requiresAuth: true,
          },
          component: ClassAttendance,
        },
        {
          path: "class_attendance/add",
          name: "Add Class Attendance",
          meta: {
            requiresAuth: true,
          },
          component: ClassAttendanceManualAdd,
        },
        {
          path: "gym_attendance",
          name: "Gym Attendance",
          meta: {
            requiresAuth: true,
          },
          component: GymAttendance,
        },
        {
          path: "gym_attendance/add",
          name: "Add Gym Attendance",
          meta: {
            requiresAuth: true,
          },
          component: GymAttendanceManualAdd,
        },
        {
          path: "booking_history",
          name: "Booking History",
          meta: {
            requiresAuth: true,
          },
          component: BookingHistory,
        },
        {
          path: "transaction_history",
          name: "Transaction History",
          meta: {
            requiresAuth: true,
          },
          component: TransactionHistory,
        },
        {
          path: "slideBanner",
          name: "Slide Banner",
          meta: {
            requiresAuth: true,
          },
          component: SlideBanner,
        },
        {
          path: "slideBanner/add",
          name: "Add Slide Banner",
          meta: {
            requiresAuth: true,
          },
          component: AddSlideBanner,
        },
        {
          path: "slideBanner/edit",
          name: "Edit Slide Banner",
          meta: {
            requiresAuth: true,
          },
          component: EditSlideBanner,
        },
        {
          path: "memberPrivilege",
          name: "Member Privilege",
          meta: {
            requiresAuth: true,
          },
          component: MemberPrivilege,
        },
        {
          path: "memberWristband",
          name: "Member Wristband",
          meta: {
            requiresAuth: true,
          },
          component: MemberWristband,
        },
        {
          path: "memberPrivilege/add",
          name: "Add Member Privilege",
          meta: {
            requiresAuth: true,
          },
          component: AddMemberPrivilege,
        },
        {
          path: "memberPrivilege/edit/:slug",
          name: "Edit Member Privilege",
          meta: {
            requiresAuth: true,
          },
          component: EditMemberPrivilege,
        },
        {
          path: "classes",
          name: "Classes",
          meta: {
            requiresAuth: true,
          },
          component: Classes,
        },
        {
          path: "classes/add",
          name: "Add Classes",
          meta: {
            requiresAuth: true,
          },
          component: AddClasses,
        },
        {
          path: "classes/edit",
          name: "Edit Classes",
          meta: {
            requiresAuth: true,
          },
          component: EditClasses,
        },
        {
          path: "classesTime",
          name: "Classes Time",
          meta: {
            requiresAuth: true,
          },
          component: ClassesTime,
        },
        {
          path: "classesTime/add",
          name: "Add Classes Time",
          meta: {
            requiresAuth: true,
          },
          component: AddClassesTime,
        },
        {
          path: "classesTime/edit",
          name: "Edit Classes Time",
          meta: {
            requiresAuth: true,
          },
          component: EditClassesTime,
        },
        {
          path: "collectStamp",
          name: "Collect Stamp",
          meta: {
            requiresAuth: true,
          },
          component: CollectStamp,
        },
        {
          path: "collectStamp/add",
          name: "Add Collect Stamp",
          meta: {
            requiresAuth: true,
          },
          component: addCollectStamp,
        },
        {
          path: "collectStamp/edit",
          name: "Edit Collect Stamp",
          meta: {
            requiresAuth: true,
          },
          component: EditCollectStamp,
        },
        {
          path: "studio",
          name: "Studio",
          meta: {
            requiresAuth: true,
          },
          component: Studio,
        },
        {
          path: "studio/add",
          name: "Add Studio",
          meta: {
            requiresAuth: true,
          },
          component: AddStudio,
        },
        {
          path: "studio/edit",
          name: "Edit Studio",
          meta: {
            requiresAuth: true,
          },
          component: EditStudio,
        },
        {
          path: "studio/cycling_seat",
          name: "Cyling Seat",
          meta: {
            requiresAuth: true,
          },
          component: CyclingLayouts,
        },
        {
          path: "classCategory",
          name: "Class Category",
          meta: {
            requiresAuth: true,
          },
          component: ClassCategory,
        },
        {
          path: "classCategory/add",
          name: "Add Class Category",
          meta: {
            requiresAuth: true,
          },
          component: AddClassCategory,
        },
        {
          path: "classCategory/edit",
          name: "Edit Class Category",
          meta: {
            requiresAuth: true,
          },
          component: EditClassCategory,
        },
        {
          path: "coach",
          name: "Instructor",
          meta: {
            requiresAuth: true,
          },
          component: Coach,
        },
        {
          path: "coach/add",
          name: "Add Instructor",
          meta: {
            requiresAuth: true,
          },
          component: AddCoach,
        },
        {
          path: "coach/edit",
          name: "Edit Instructor",
          meta: {
            requiresAuth: true,
          },
          component: EditCoach,
        },
        {
          path: "schedule",
          name: "Schedule",
          meta: {
            requiresAuth: true,
          },
          component: Schedule,
        },
        {
          path: "schedule/add",
          name: "Add Schedule",
          meta: {
            requiresAuth: true,
          },
          component: AddSchedule,
        },
        {
          path: "schedule/edit",
          name: "Edit Schedule",
          meta: {
            requiresAuth: true,
          },
          component: EditSchedule,
        },
        {
          path: "blog",
          name: "Blog",
          meta: {
            requiresAuth: true,
          },
          component: Blog,
        },
        {
          path: "blog/add",
          name: "Add Blog",
          meta: {
            requiresAuth: true,
          },
          component: AddBlog,
        },
        {
          path: "blog/edit/:slug",
          name: "Edit Blog",
          meta: {
            requiresAuth: true,
          },
          component: EditBlog,
        },
        {
          path: "blogCategory",
          name: "Blog Category",
          meta: {
            requiresAuth: true,
          },
          component: BlogCategory,
        },
        {
          path: "blogCategory/add",
          name: "Add Blog Category",
          meta: {
            requiresAuth: true,
          },
          component: AddBlogCategory,
        },
        {
          path: "blogCategory/edit",
          name: "Edit Blog Category",
          meta: {
            requiresAuth: true,
          },
          component: EditBlogCategory,
        },
        {
          path: "memberPrivilegeCategory",
          name: "Member Privilege Category",
          meta: {
            requiresAuth: true,
          },
          component: MemberPrivilegeCategory,
        },
        {
          path: "memberPrivilegeCategory/add",
          name: "Add Member Privilege Category",
          meta: {
            requiresAuth: true,
          },
          component: AddMemberPrivilegeCategory,
        },
        {
          path: "memberPrivilegeCategory/edit",
          name: "Edit Member Privilege Category",
          meta: {
            requiresAuth: true,
          },
          component: EditMemberPrivilegeCategory,
        },
        {
          path: "gallery",
          name: "Gallery",
          meta: {
            requiresAuth: true,
          },
          component: Gallery,
        },
        {
          path: "gallery/add",
          name: "Add Gallery",
          meta: {
            requiresAuth: true,
          },
          component: AddGallery,
        },
        {
          path: "gallery/edit",
          name: "Edit Gallery",
          meta: {
            requiresAuth: true,
          },
          component: EditGallery,
        },
        {
          path: "personalTraining",
          name: "Personal Training",
          meta: {
            requiresAuth: true,
          },
          component: PersonalTraining,
        },
        {
          path: "personalTraining/add",
          name: "Add Personal Training",
          meta: {
            requiresAuth: true,
          },
          component: AddPersonalTraining,
        },
        {
          path: "personalTraining/edit",
          name: "Edit Personal Training",
          meta: {
            requiresAuth: true,
          },
          component: EditPersonalTraining,
        },
        {
          path: "sales",
          name: "Sales",
          meta: {
            requiresAuth: true,
          },
          component: Sales,
        },
        {
          path: "sales/add",
          name: "Add Sales",
          meta: {
            requiresAuth: true,
          },
          component: AddSales,
        },
        {
          path: "sales/edit",
          name: "Edit Sales",
          meta: {
            requiresAuth: true,
          },
          component: EditSales,
        },
        {
          path: "salesMapping",
          name: "Sales Mapping",
          meta: {
            requiresAuth: true,
          },
          component: SalesMapping,
        },
        {
          path: "salesMapping/add",
          name: "Add Sales Mapping",
          meta: {
            requiresAuth: true,
          },
          component: AddSalesMapping,
        },
        {
          path: "salesMapping/edit",
          name: "Edit Sales Mapping",
          meta: {
            requiresAuth: true,
          },
          component: EditSalesMapping,
        },
        {
          path: "salesManager",
          name: "Sales Manager",
          meta: {
            requiresAuth: true,
          },
          component: SalesManager,
        },
        {
          path: "salesManager/add",
          name: "Add Sales Manager",
          meta: {
            requiresAuth: true,
          },
          component: AddSalesManager,
        },
        {
          path: "salesManager/edit",
          name: "Edit Sales Manager",
          meta: {
            requiresAuth: true,
          },
          component: EditSalesManager,
        },
        {
          path: "customerService",
          name: "Customer Services",
          meta: {
            requiresAuth: true,
          },
          component: CustomerServices,
        },
        {
          path: "customerService/add",
          name: "Add Customer Services",
          meta: {
            requiresAuth: true,
          },
          component: AddCustomerServices,
        },
        {
          path: "customerService/edit",
          name: "Edit Customer Services",
          meta: {
            requiresAuth: true,
          },
          component: EditCustomerServices,
        },
        // {
        //   path: 'user/list',
        //   name: 'List User',
        //   meta: { requiresAuth: true },
        //   component: UserList
        // },
        {
          path: "branch",
          name: "Branch",
          meta: {
            requiresAuth: true,
          },
          component: Branch,
        },
        {
          path: "branch/add",
          name: "Add Branch",
          meta: {
            requiresAuth: true,
          },
          component: AddBranch,
        },
        {
          path: "branch/edit",
          name: "Edit Branch",
          meta: {
            requiresAuth: true,
          },
          component: EditBranch,
        },
        {
          path: "ptSession/add",
          name: "Add PT Session",
          meta: {
            requiresAuth: true,
          },
          component: AddPtSession,
        },
        {
          path: "ptSession/edit",
          name: "Edit PT Session",
          meta: {
            requiresAuth: true,
          },
          component: EditPtSession,
        },
        {
          path: "ptSession",
          name: "PT Session",
          meta: {
            requiresAuth: true,
          },
          component: PtSession,
        },
        {
          path: "ptSessionBuy",
          name: "Buy PT Session",
          meta: {
            requiresAuth: true,
          },
          component: PtSessionBuy,
        },
        {
          path: "ptSessionBuy/add",
          name: "Add Buy PT Session",
          meta: {
            requiresAuth: true,
          },
          component: AddPtSessionBuy,
        },
        {
          path: "ptSessionBuy/edit",
          name: "Edit Buy PT Session",
          meta: {
            requiresAuth: true,
          },
          component: EditPtSessionBuy,
        },
        {
          path: "ptSessionMember",
          name: "PT Session Member",
          meta: {
            requiresAuth: true,
          },
          component: PtSessionMember,
        },
        {
          path: "ptSessionMember/add",
          name: "Add PT Session Member",
          meta: {
            requiresAuth: true,
          },
          component: AddPtSessionMember,
        },
        {
          path: "ptSessionMember/edit",
          name: "Edit PT Session Member",
          meta: {
            requiresAuth: true,
          },
          component: EditPtSessionMember,
        },
        {
          path: "registerWristband",
          name: "Wristband Registration",
          meta: {
            requiresAuth: true,
          },
          component: RegisterWristband,
        },
        {
          path: "ptReport/ptLog",
          name: "PT Log",
          meta: {
            requiresAuth: true,
          },
          component: PtLog,
        },
        {
          path: "ptReport/ptBackToBasic",
          name: "PT Back to Basic",
          meta: {
            requiresAuth: true,
          },
          component: PtBackToBasic,
        },
        {
          path: "ptReport/ptBestOfTheBest",
          name: "PT Best of the Best",
          meta: {
            requiresAuth: true,
          },
          component: PtBestOfTheBest,
        },
        {
          path: "ptReport/ptCommissionSetting/index",
          name: "PT Commission Setting",
          meta: {
            requiresAuth: true,
          },
          component: PtCommissionSettingIndex,
        },
        {
          path: "ptReport/ptCommissionSetting/add",
          name: "Add PT Commission Setting",
          meta: {
            requiresAuth: true,
          },
          component: PtCommissionSettingAdd,
        },
        {
          path: "ptReport/ptCommissionTier/index",
          name: "PT Commission Tier Setting",
          meta: {
            requiresAuth: true,
          },
          component: PtCommissionTierIndex,
        },
        // {
        //   path: 'ptReport/assesment',
        //   name: 'PHA Log',
        //   meta: { requiresAuth: true },
        //   component: PtReportAssesment
        // },
        {
          path: "ptReport/usageLog",
          name: "Usage Log",
          meta: {
            requiresAuth: true,
          },
          component: PtReportUsageLog,
        },
        {
          path: "ptReport/salesCommission",
          name: "Komisi Sales",
          meta: {
            requiresAuth: true,
          },
          component: PtReportSalesCommission,
        },
        {
          path: "allForm",
          name: "All Form",
          meta: {
            requiresAuth: true,
          },
          component: AllForm,
        },
        {
          path: "allForm/add",
          name: "Add Form",
          meta: {
            requiresAuth: true,
          },
          component: AddForm,
        },
        {
          path: "allForm/addFreeze",
          name: "Add Form Freeze",
          meta: {
            requiresAuth: true,
          },
          component: AddFormFreeze,
        },
        {
          path: "allForm/addMerchandise",
          name: "Add Form Merchandise",
          meta: {
            requiresAuth: true,
          },
          component: AddFormMerchandise
        },
        {
          path: "allForm/addStarterPack",
          name: "Add Form Starter Pack",
          meta: {
            requiresAuth: true,
          },
          component: AddFormStarterPack,
        },
        {
          path: "allForm/addCancel",
          name: "Add Form Cancel",
          meta: {
            requiresAuth: true,
          },
          component: AddFormCancel,
        },
        {
          path: "allForm/addOutstanding",
          name: "Add Form Outstanding",
          meta: {
            requiresAuth: true,
          },
          component: AddFormOutstanding,
        },
        {
          path: "allForm/addWristband",
          name: "Add Form Wristband",
          meta: {
            requiresAuth: true,
          },
          component: AddFormWristband,
        },
        {
          path: "allForm/addExtendPt",
          name: "Extend PT",
          meta: {
            requiresAuth: true,
          },
          component: AddExtendForm,
        },
        {
          path: "allForm/addDailyVisit",
          name: "Add Form Daily Visit",
          meta: {
            requiresAuth: true,
          },
          component: AddFormDailyVisit,
        },
        {
          path: "allForm/editDailyVisit",
          name: "Edit Form Daily Visit",
          meta: {
            requiresAuth: true,
          },
          component: EditFormDailyVisit,
        },
        {
          path: "allForm/addGrabAndGo",
          name: "Add Form Grab & Go",
          meta: {
            requiresAuth: true,
          },
          component: AddFormGrabAndGo,
        },
        {
          path: "allForm/addGrabAndGoGopay",
          name: "Add Form Grab & Go Gopay",
          meta: {
            requiresAuth: true,
          },
          component: AddFormGrabAndGoGopay,
        },
        {
          path: "allForm/editGrabAndGo",
          name: "Edit Form Grab & Go",
          meta: {
            requiresAuth: true,
          },
          component: EditFormGrabAndGo,
        },
        {
          path: "allForm/editGrabAndGoGopay",
          name: "Edit Form Grab & Go Gopay",
          meta: {
            requiresAuth: true,
          },
          component: EditFormGrabAndGoGopay,
        },
        {
          path: "allForm/addCorporateOutstanding",
          name: "Add Corporate Outstanding",
          meta: {
            requiresAuth: true,
          },
          component: AddCorporateOutstanding,
        },
        {
          path: "allForm/editCorporateOutstanding",
          name: "Edit Corporate Outstanding",
          meta: {
            requiresAuth: true,
          },
          component: EditCorporateOutstanding,
        },
        {
          path: "allForm/grabAndGoProduct",
          name: "Grab & Go Product",
          meta: {
            requiresAuth: true,
          },
          component: GrabAndGoProduct,
        },
        // {
        //   path: 'allForm/grabAndGoProduct/add',
        //   name: 'Add Grab & Go Product',
        //   meta: { requiresAuth: true },
        //   component: AddGrabAndGoProduct
        // },
        {
          path: "allForm/grabAndGoProduct/edit",
          name: "Edit Grab & Go Product",
          meta: {
            requiresAuth: true,
          },
          component: EditGrabAndGoProduct,
        },
        {
          path: "allForm/addLostAndFound",
          name: "Add Form Lost & Found",
          meta: {
            requiresAuth: true,
          },
          component: AddFormLostAndFound,
        },
        {
          path: "allForm/editLostAndFound",
          name: "Edit Form Lost & Found",
          meta: {
            requiresAuth: true,
          },
          component: EditFormLostAndFound,
        },
        {
          path: "allForm/editCancel",
          name: "Edit Cancel",
          meta: {
            requiresAuth: true,
          },
          component: EditCancel,
        },
        {
          path: "allForm/editFreeze",
          name: "Edit Freeze",
          meta: {
            requiresAuth: true,
          },
          component: EditFreeze,
        },
        {
          path: "groupFitness/attendance",
          name: "Group Fitness Attendance",
          meta: {
            requiresAuth: true,
          },
          component: GroupFitnessAttendance,
        },
        {
          path: "attendance/group_fitness",
          name: "Group Fitness Attendance",
          meta: {
            requiresAuth: true,
          },
          component: GroupFitnessNewAttendance,
        },
        {
          path: "attendance/group_fitness_botb",
          name: "Group Fitness Botb",
          meta: {
            requiresAuth: true,
          },
          component: GroupFitnessBotb,
        },
        {
          path: "attendance/instructor",
          name: "Instructor Attendance",
          meta: {
            requiresAuth: true,
          },
          component: InstructorAttendance,
        },
        {
          path: "groupFitness/best-of-the-best",
          name: "Best of the Best GF",
          meta: {
            requiresAuth: true,
          },
          component: GroupFitnessBestOfTheBest,
        },
        {
          path: "groupFitness/comission",
          name: "Group Fitness Comission",
          meta: {
            requiresAuth: true,
          },
          component: GroupFitnessComission,
        },
        {
          path: "groupFitness/cnr",
          name: "Group Fitness CNR",
          meta: {
            requiresAuth: true,
          },
          component: GroupFitnessCNR,
        },
        {
          path: "groupFitness/summary",
          name: "Group Fitness Summary",
          meta: {
            requiresAuth: true,
          },
          component: GroupFitnessSummary,
        },

        {
          path: "formReport/freeze",
          name: "Freeze Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportFreeze,
        },
        {
          path: "formReport/extend",
          name: "Extend PT Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportExtend,
        },
        {
          path: "formReport/cancel",
          name: "Cancel Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportCancel,
        },
        {
          path: "formReport/outstanding",
          name: "Outstanding Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportOutstanding,
        },
        {
          path: "formReport/autocollection",
          name: "Autocollection Result",
          meta: {
            requiresAuth: true,
          },
          component: ReportAutoCollection,
        },
        {
          path: "formReport/add_autocollection",
          name: "Add Auto Collection",
          meta: {
            requiresAuth: true,
          },
          component: AddAutoCollection,
        },
        {
          path: "formReport/wristband",
          name: "Wristband Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportWristband,
        },
        {
          path: "formReport/lostAndFound",
          name: "Lost & Found Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportLostAndFound,
        },
        {
          path: "formReport/dailyVisit",
          name: "Daily Visit Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportDailyVisit,
        },

        {
          path: "formReport/grabAndGo",
          name: "Grab & Go Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportGrabAndGo,
        },
        {
          path: "formReport/autopay_midtrans",
          name: "Autopay Midtrans",
          meta: {
            requiresAuth: true,
          },
          component: ReportAutopayMidtrans,
        },
        {
          path: "formReport/draft_bank",
          name: "Draft Bank",
          meta: {
            requiresAuth: true,
          },
          component: ReportDraftBank,
        },
        {
          path: "formReport/grabAndGoGopay",
          name: "Grab & Go Gopay Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportGrabAndGoGopay,
        },
        {
          path: "formReport/corporateOutstanding",
          name: "Corporate Outstanding",
          meta: {
            requiresAuth: true,
          },
          component: ReportCorporateOutstanding,
        },
        {
          path: "formReport/merchandise",
          name: "Merchandise Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportMerchandise,
        },
        {
          path: "formReport/member_voucher_report",
          name: "Member Voucher Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportMemberVoucher,
        },
        {
          path: "formReport/member-point-report",
          name: "Member Point Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportMemberPoint,
        },
        {
          path: "formReport/log_update_fop",
          name: "Log Update FOP",
          meta: {
            requiresAuth: true,
          },
          component: ReportLogUpdateFOP,
        },
        {
          path: "memberPointScheme",
          name: "Skema Point",
          meta: {
            requiresAuth: true,
          },
          component: MemberPointScheme,
        },

        {
          path: "faq",
          name: "Faq",
          meta: {
            requiresAuth: true,
          },
          component: Faq,
        },
        {
          path: "faq/add",
          name: "Add Faq",
          meta: {
            requiresAuth: true,
          },
          component: AddFaq,
        },
        {
          path: "faq/edit",
          name: "Edit Faq",
          meta: {
            requiresAuth: true,
          },
          component: EditFaq,
        },
        {
          path: "event",
          name: "Event",
          meta: {
            requiresAuth: true,
          },
          component: Event,
        },
        {
          path: "event/add",
          name: "Add Event",
          meta: {
            requiresAuth: true,
          },
          component: AddEvent,
        },
        {
          path: "event/edit/:slug",
          name: "Edit Event",
          meta: {
            requiresAuth: true,
          },
          component: EditEvent,
        },
        {
          path: "membership",
          name: "Membership",
          meta: {
            requiresAuth: true,
          },
          component: Membership,
        },
        {
          path: "membership/add",
          name: "Add Membership",
          meta: {
            requiresAuth: true,
          },
          component: AddMembership,
        },
        {
          path: "membership/edit",
          name: "Edit Membership",
          meta: {
            requiresAuth: true,
          },
          component: EditMembership,
        },
        {
          path: "membershipSessionProrate",
          name: "Membership Session Prorate",
          meta: {
            requiresAuth: true,
          },
          component: MembershipSessionProrate,
        },
        {
          path: "membershipSessionProrate/add",
          name: "Add Membership Session Prorate",
          meta: {
            requiresAuth: true,
          },
          component: AddMembershipSessionProrate,
        },
        {
          path: "membershipSessionProrate/edit",
          name: "Edit Membership Session Prorate",
          meta: {
            requiresAuth: true,
          },
          component: EditMembershipSessionProrate,
        },
        {
          path: "package",
          name: "Package",
          meta: {
            requiresAuth: true,
          },
          component: Package,
        },
        {
          path: "package/add",
          name: "Add Package",
          meta: {
            requiresAuth: true,
          },
          component: AddPackage,
        },
        {
          path: "package/edit/:slug",
          name: "Edit Package",
          meta: {
            requiresAuth: true,
          },
          component: EditPackage,
        },
        {
          path: "transaction",
          name: "Transaction",
          meta: {
            requiresAuth: true,
          },
          component: Transaction,
        },
        {
          path: "transaction/add",
          name: "Add Transaction",
          meta: {
            requiresAuth: true,
          },
          component: AddTransaction,
        },
        {
          path: "transaction/edit",
          name: "Edit Transaction",
          meta: {
            requiresAuth: true,
          },
          component: EditTransaction,
        },
        {
          path: "userManagement/user",
          name: "User",
          meta: {
            requiresAuth: true,
          },
          component: User,
        },
        {
          path: "userManagement/user/add",
          name: "Add User",
          meta: {
            requiresAuth: true,
          },
          component: AddUser,
        },
        {
          path: "userManagement/user/edit",
          name: "Edit User",
          meta: {
            requiresAuth: true,
          },
          component: EditUser,
        },
        {
          path: "userManagement/userRole",
          name: "User Role",
          meta: {
            requiresAuth: true,
          },
          component: UserRole,
        },
        {
          path: "userManagement/userRole/add",
          name: "Add User Role",
          meta: {
            requiresAuth: true,
          },
          component: AddUserRole,
        },
        {
          path: "userManagement/userRole/edit",
          name: "Edit User Role",
          meta: {
            requiresAuth: true,
          },
          component: EditUserRole,
        },
        {
          path: "userManagement/userAccessMenu",
          name: "User Access Menu",
          meta: {
            requiresAuth: true,
          },
          component: UserAccessMenu,
        },
        {
          path: "userManagement/userAccessMenu/add",
          name: "Add Access Menu",
          meta: {
            requiresAuth: true,
          },
          component: AddUserAccessMenu,
        },
        {
          path: "userManagement/userAccessMenu/edit",
          name: "Edit Access Menu",
          meta: {
            requiresAuth: true,
          },
          component: EditUserAccessMenu,
        },
        {
          path: "userManagement/userRoleMapping",
          name: "User Role Mapping",
          meta: {
            requiresAuth: true,
          },
          component: UserRoleMapping,
        },
        {
          path: "userManagement/userRoleMapping/add",
          name: "Add User Role Mapping",
          meta: {
            requiresAuth: true,
          },
          component: AddUserRoleMapping,
        },
        {
          path: "userManagement/userRoleMapping/edit",
          name: "Edit User Role Mapping",
          meta: {
            requiresAuth: true,
          },
          component: EditUserRoleMapping,
        },
        {
          path: "userManagement/approval-roles",
          name: "Approval Roles",
          meta: {
            requiresAuth: true,
          },
          component: ApprovalRoles,
        },
        {
          path: "userManagement/approval-roles/add",
          name: "Add New",
          meta: {
            requiresAuth: true,
          },
          component: ApprovalRolesAdd,
        },
        {
          path: "userManagement/approval-roles/edit",
          name: "Edit",
          meta: {
            requiresAuth: true,
          },
          component: ApprovalRolesEdit,
        },
        {
          path: "memberDiary/subCategory",
          name: "SubCategory Member Diary",
          meta: {
            requiresAuth: true,
          },
          component: memberDiarySubCategory,
        },
        {
          path: "memberDiary/subCategory/add",
          name: "SubCategory Member Diary Add",
          meta: {
            requiresAuth: true,
          },
          component: memberDiarySubCategoryManage,
        },
        {
          path: "memberDiary/subCategory/edit/:id",
          name: "SubCategory Member Diary Edit",
          meta: {
            requiresAuth: true,
          },
          component: memberDiarySubCategoryManage,
        },
        {
          path: "memberDiary/activity",
          name: "Activity Member Diary",
          meta: {
            requiresAuth: true,
          },
          component: memberDiaryActivity,
        },
        {
          path: "memberDiary/activity/add",
          name: "Activity Member Diary Add",
          meta: {
            requiresAuth: true,
          },
          component: memberDiaryActivityManage,
        },
        {
          path: "memberDiary/activity/edit/:id",
          name: "Activity Member Diary Edit",
          meta: {
            requiresAuth: true,
          },
          component: memberDiaryActivityManage,
        },
        {
          path: "corporate/",
          name: "Corporate List",
          meta: {
            requiresAuth: true,
          },
          component: Corporate,
        },
        {
          path: "corporate/add",
          name: "Corporate Add",
          meta: {
            requiresAuth: true,
          },
          component: ManageCorporate,
        },
        {
          path: "corporate/edit/:id",
          name: "Corporate Edit",
          meta: {
            requiresAuth: true,
          },
          component: ManageCorporate,
        },
        {
          path: "keysoft/history",
          name: "Keysoft History",
          meta: {
            requiresAuth: true,
          },
          component: KeysoftHistory,
        },
        {
          path: "keysoft/reportOutstanding",
          name: "Report Outstanding",
          meta: {
            requiresAuth: true,
          },
          component: ReportOutstandingPtSession,
        },
        {
          path: "keysoft/sync",
          name: "Keysoft Sync",
          meta: {
            requiresAuth: true,
          },
          component: KeysoftSync,
        },
        {
          path: "frontendSetting/groupFitness",
          name: "Group Fitness Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_GroupFitness,
        },
        {
          path: "frontendSetting/groupFitness/add",
          name: "Add Group Fitness Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_AddGroupFitness,
        },
        {
          path: "frontendSetting/groupFitness/edit/:id",
          name: "Edit Group Fitness Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_EditGroupFitness,
        },
        {
          path: "frontendSetting/PHA",
          name: "PHA Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_Pha,
        },
        {
          path: "frontendSetting/PHA/add",
          name: "Add PHA Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_AddPha,
        },
        {
          path: "frontendSetting/PHA/edit/:id",
          name: "Edit PHA Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_EditPha,
        },
        {
          path: "frontendSetting/Program",
          name: "Program Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_Program,
        },
        {
          path: "frontendSetting/Program/add",
          name: "Add Program Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_AddProgram,
        },
        {
          path: "frontendSetting/Program/edit/:id",
          name: "Edit Program Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_EditProgram,
        },
        {
          path: "frontendSetting/VideoHome",
          name: "Video Home Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_VideoHome,
        },
        {
          path: "frontendSetting/VideoHome/add",
          name: "Add Video Home Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_AddVideoHome,
        },
        {
          path: "frontendSetting/VideoHome/edit/:id",
          name: "Edit Video Home Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_EditVideoHome,
        },
        {
          path: "frontendSetting/VideoGF",
          name: "Video Group Fitness Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_VideoGF,
        },
        {
          path: "frontendSetting/VideoGF/add",
          name: "Add Video Group Fitness Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_AddVideoGF,
        },
        {
          path: "frontendSetting/VideoGF/edit/:id",
          name: "Edit Video Group Fitness Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_EditVideoGF,
        },
        {
          path: "frontendSetting/VideoPT",
          name: "Video PT Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_VideoPT,
        },
        {
          path: "frontendSetting/VideoPT/add",
          name: "Add Video PT Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_AddVideoPT,
        },
        {
          path: "frontendSetting/VideoPT/edit/:id",
          name: "Edit Video PT Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_EditVideoPT,
        },
        {
          path: "frontendSetting/paradigmStandard",
          name: "Paragidm Standard",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_ParadigmStandard,
        },
        {
          path: "frontendSetting/StudioSchedule",
          name: "Studio Schedule Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_StudioSchedule,
        },
        {
          path: "frontendSetting/StudioSchedule/add",
          name: "Add Studio Schedule Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_AddStudioSchedule,
        },
        {
          path: "frontendSetting/StudioSchedule/edit/:id",
          name: "Edit Studio Schedule Frontend",
          meta: {
            requiresAuth: true,
          },
          component: FrontendSetting_EditStudioSchedule,
        },
        {
          path: "schedulePtAppointment",
          name: "Schedule PT Appointment",
          meta: {
            requiresAuth: true,
          },
          component: SchedulePtAppointment,
        },
        {
          path: "logs/faceLogs",
          name: "Face App Logs",
          meta: {
            requiresAuth: true,
          },
          component: FaceLogs,
        },
        {
          path: "logs/cancelLogs",
          name: "Cancel Logs",
          meta: {
            requiresAuth: true,
          },
          component: CancelLogs
        },
        {
          path: "finance/bank-book",
          name: "Bank Book",
          meta: {
            requiresAuth: true,
          },
          component: FinanceBankBook,
        },
        {
          path: "finance/membership-log",
          name: "Membership Log",
          meta: {
            requiresAuth: true,
          },
          component: FinanceMembershipLog,
        },
        {
          path: "finance/revenue-log",
          name: "Other Revenue Log",
          meta: {
            requiresAuth: true,
          },
          component: RevenueLog,
        },
        {
          path: "finance/pt-log",
          name: "PT Log",
          meta: {
            requiresAuth: true,
          },
          component: FinancePtLog,
        },
        {
          path: "finance/pt-running",
          name: "PT Running",
          meta: {
            requiresAuth: true,
          },
          component: FinancePtRunning,
        },
        {
          path: "finance/last-dues-recognition-log",
          name: "Last Dues Recognition Log",
          meta: {
            requiresAuth: true,
          },
          component: FinanceLastDuesRecognitionLog,
        },
        {
          path: "finance/merchandise-log",
          name: "Merchandise Log",
          meta: {
            requiresAuth: true,
          },
          component: FinanceMerchandiseLog,
        },
        {
          path: "finance/pt-session-analysis",
          name: "PT Session Analysis",
          meta: {
            requiresAuth: true,
          },
          component: FinancePTSessionAnalysis,
        },
        {
          path: "finance/membership-analysis",
          name: "Membership Analysis",
          meta: {
            requiresAuth: true,
          },
          component: FinanceMembershipAnalysis,
        },
        {
          path: "closingPeriod",
          name: "Closing Period",
          meta: {
            requiresAuth: true,
          },
          component: ClosingPeriodMenu,
        },
        {
          path: "finance/term_membership",
          name: "Term Membership",
          meta: {
            requiresAuth: true,
          },
          component: FinanceTermMembership
        },
        {
          path: "finance/running_pt_balance",
          name: "Running PT Balance",
          meta: {
            requiresAuth: true,
          },
          component: FinanceRunningPTBalance
        },
        {
          path: "finance/redeem_point",
          name: "Redeem Point",
          meta: {
            requiresAuth: true,
          },
          component: FinanceRedeemPointReport,
        },
        {
          path: "report/autopay",
          name: "Auto Pay Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportAutoPay,
        },
        {
          path: "report/motto",
          name: "Motto Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportMotto,
        },
        {
          path: "report/autocollection",
          name: "Auto Collection Data",
          meta: {
            requiresAuth: true,
          },
          component: ReportNewAutoCollection,
        },
        {
          path: "report/autopayresults",
          name: "Autopay Results",
          meta: {
            requiresAuth: true,
          },
          component: ReportAutoPayResults,
        },
        {
          path: "report/outstanding",
          name: "Report Member Outstanding",
          meta: {
            requiresAuth: true,
          },
          component: ReportMemberOutstanding,
        },
        {
          path: "report/ptfeedback",
          name: "PT Feedback Report",
          meta: {
            requiresAuth: true,
          },
          component: ReportPtFeedback,
        },
        {
          path: "report/session-expired",
          name: "Session Expired",
          meta: {
            requiresAuth: true,
          },
          component: ReportSessionExpired,
        },
        {
          path: "approval",
          name: "Approval Menu",
          meta: {
            requiresAuth: true,
          },
          component: ApprovalMenu,
        },
      ],
    },
  ],
});
// $route.query redirect di login biar lgsung masuk ke spesifik
router.beforeEach((to, from, next) => {
  // console.log(to.path)
  let menus = Auth.Session.get("paradigm_cached_menus");
  if (menus) {
    // console.log('Menus Cached: ', menus)
    // const menuPath = `${to.path}`.replace('/', '')
    menus = JSON.parse(menus)
    if (menus.length > 0) {
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        // console.log('Menu: ', menu)
        if (menu.children && menu.children.length > 0) {
          const filterMenu = menu.children.find((m) => to.path.includes(m.url))
          if (filterMenu) {
            // add id to meta data
            to.meta['id'] = filterMenu.id
            // console.log('Meta Data', to.meta)
            // set selected menu to localstorage
            localStorage.setItem('paradigm_cached_selected_menu', filterMenu.id)

            axios.defaults.headers.common['X-Menu-Id'] = filterMenu.id
          }
        }
      }
    }
    // const filterMenus = menus.find((m) => console.log(m))
    // console.log('Menu Path: ', menuPath)
    // console.log('Matched Menu Selected: ', filterMenus)
  }

  let session = Auth.Session.get();
  if (to.meta.requiresAuth) {
    if (!session.paradigm_id) {
      Auth.Session.delete();
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    } else next();
  } else next();
});

export default router;
